import React from "react";
import { useNavigate } from "react-router-dom";
import MainPresenter from "./MainPresenter";
import { useScrollTop } from '../../hooks';
import { artist } from '../../api';

import ajm from '../../images/ajm/profile/1.webp';
import ghe from '../../images/ghe/profile/1.webp';
import jhs from '../../images/jhs/profile/1.webp';
import jns from '../../images/jns/profile/1.webp';
import krn from '../../images/krn/profile/krn-profile-05.webp';
import kbb from '../../images/kbb/profile/kbb-profile-03.webp';
import lsk from '../../images/lsk/profile/lsk-profile-01.webp';
import oskar from '../../images/oskar/profile/oskar-profile-02.webp';
import cwk from '../../images/cwk/profile/cwk-profile-01.webp';

const mainInitState = [
  { id: 'jhs', name: 'Jung Hye Seon', img: jhs },
  { id: 'ajm', name: 'Ahn Jae Mo', img: ajm },
  { id: 'lsk', name: 'Lee Su Kyung', img: lsk },
  { id: 'kbb', name: 'Kim Bibi', img: kbb },
  { id: 'jns', name: 'Jang Nam Su', img: jns },
  { id: 'ghe', name: 'Gil Ha Eun', img: ghe },
  { id: 'krn', name: 'Kim Ri-na', img: krn },
  { id: 'oskar', name: 'OSKAR KEEM', img: oskar },
  { id: 'cwk', name: 'Chun Woo-Kyoung', img: cwk },
];

const MainContainer = () => {
  const [main, setMain] = React.useState(mainInitState);
  const navigate = useNavigate();

  const navigateToProfile = (id) => { 
    navigate(`/artist/${id}`); 
  }

  const getMain = async () => {
    try {
      const response = await artist.getArtist();
      console.log('[getMain] response.data : ', response.data);
      // setMain(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    // getMain();
  }, []);
  
  useScrollTop();

  return <MainPresenter main={main} navigateToProfile={navigateToProfile} />;
};

export default MainContainer;
